import React from 'react';
import PropTypes from 'prop-types';

import './styles.module.css';

const QuestionnaireStep = ({ context, title, icon, children }) => ([
  <div styleName="step" key={title}>
    {icon && <img styleName="icon" src={icon} role="presentation" />}
    <div styleName="wrap">
      <p styleName="context">{context}</p>
      <h4 styleName="title">{title}</h4>
    </div>
    <div styleName="separator" />
  </div>,
  children
]);

QuestionnaireStep.propTypes = {
  context: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.array
};

export default QuestionnaireStep;